// The Space presence card shown, in BI — SHARED CONTRACT with iOS `PresenceHeader` and Android `PresenceHeader`
// (keep the component name, the field keys and the enum values identical on all three surfaces).
//
// One src:198 itemSeen (evid 6), component `space-presence-card`, fired when the Space's presence header is shown
// (and again if its state changes while it stays on screen), carrying
//  - `state`: the ONE next step the header offers (`presenceNextStep`) lowercased — go_live | upgrade |
//    connect_domain | reconnect | verify — or `complete` when it offers none.
//  - `platform`: web
// The user's Go live / upgrade / domain taps are the existing `presence_next_step_<kind>` clicks on the same page.
// Ids, enums and counts only.

import type { PresenceNextStep } from './presence';

export const SPACE_PRESENCE_CARD_COMPONENT = 'space-presence-card';
export const SPACE_PRESENCE_BI_PLATFORM = 'web';

export type SpacePresenceState = 'go_live' | 'upgrade' | 'connect_domain' | 'reconnect' | 'verify' | 'complete';

export function spacePresenceState(step: Pick<PresenceNextStep, 'kind'> | null | undefined): SpacePresenceState {
  return step ? (step.kind.toLowerCase() as SpacePresenceState) : 'complete';
}

export function spacePresenceBiFields(step: Pick<PresenceNextStep, 'kind'> | null | undefined): Record<string, string> {
  return { state: spacePresenceState(step), platform: SPACE_PRESENCE_BI_PLATFORM };
}
